import { styleConstants } from '@paywithextend/components'
import React from 'react'
import AccountVerificationBlocked from 'src/assets/images/AccountVerificationBlocked.svg'
import AppName from 'src/components/AppName/AppName'
import Box from 'src/components/Box/Box'
import ResourceCenterLink from 'src/components/ResourceCenterLink/ResourceCenterLink'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

const AccountVerificationBlockedBox = (): React.ReactElement => {
  return (
    <Box
      css={css`
        align-items: center;
        align-self: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 500px;
      `}
    >
      <img
        src={AccountVerificationBlocked}
        alt=""
        css={css`
          max-width: 106px;
        `}
      />
      <div
        css={css`
          display: flex;
          align-items: center;
          margin-top: 10px;
          color: ${styleConstants.colors.red};
        `}
      >
        <h3>
          <Trns source={'Verification blocked'} />
        </h3>
      </div>
      <p
        css={css`
          margin-top: 20px;
        `}
      >
        <Trns
          source={
            'For security purposes, the verification of this ${appName} account has been blocked.'
          }
          expressions={{
            appName: <AppName />,
          }}
        />
      </p>
      <p
        css={css`
          margin-top: 20px;
        `}
      >
        <Trns
          source={
            'There have been too many failed attempts at verifying the account. In order to proceed, contact us via our ${resourceCenter}.'
          }
          expressions={{
            resourceCenter: (
              <ResourceCenterLink
                underline
                css={css`
                  font-family: ${styleConstants.fontFamilies.regular};
                  font-size: 16px;

                  &:hover {
                    font-family: ${styleConstants.fontFamilies.regular};
                    font-size: 16px;
                  }
                `}
              />
            ),
          }}
        />
      </p>
    </Box>
  )
}

export default AccountVerificationBlockedBox
